import React from 'react';
import TermlyEmbed from './TermlyEmbed';

const Disclaimer = () => {
  return <TermlyEmbed dataId="9bc71f49-004a-4414-8a1f-78bd09a6c04b" />;
};

export default Disclaimer;
